/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function LanguagesIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-languages">
        <g id="Group 74 Copy 2">
          <g id="Group 72 Copy 2">
            <g id="Group 70 Copy 2">
              <g id="Group 68 Copy 2">
                <g id="Group 66 Copy 2">
                  <g id="Group 65 Copy 2">
                    <g id="Group 63 Copy 2">
                      <g id="Group 61 Copy 2">
                        <g id="Group 59 Copy 3">
                          <g id="icon-legal and finance copy">
                            <g id="Group 58 Copy 2">
                              <g id="icon-journey-course">
                                <circle
                                  id="Oval"
                                  cx="78.5"
                                  cy="78.5"
                                  r="77.5"
                                  fill={mainColor}
                                  stroke="white"
                                  stroke-width="2"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="translate copy">
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M80.8305 69.6097H110.508C115.191 69.6097 119 73.6417 119 78.5978V110.011C119 114.968 115.191 119 110.508 119H80.8305C76.5746 119 73.0396 115.668 72.4317 111.339L64.6497 105.456C64.043 104.997 63.6829 104.256 63.6829 103.467C63.6829 102.677 64.043 101.937 64.6497 101.478L72.3391 95.665V78.5978C72.3391 73.6417 76.1482 69.6097 80.8305 69.6097ZM99.4417 103.271C99.565 103.769 99.9853 103.952 100.529 103.952C101.395 103.952 102.558 103.35 102.558 102.539C102.558 102.476 102.542 102.415 102.524 102.34C102.519 102.32 102.513 102.299 102.508 102.276L97.7346 85.8101C97.5122 85.0247 96.597 84.6575 95.6572 84.6575C94.742 84.6575 93.8268 85.0247 93.6044 85.8101L88.8307 102.276L88.8298 102.28C88.8055 102.384 88.7814 102.486 88.7814 102.539C88.7814 103.376 89.9437 103.952 90.8096 103.952C91.3537 103.952 91.774 103.769 91.8979 103.271L92.8371 99.7892H98.5013L99.4417 103.271Z"
            fill={secondaryColor}
          />
          <path
            id="Path"
            d="M93.3171 97.2683H97.2684L95.2922 89.3658L93.3171 97.2683Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M65.5338 81.0193C65.5338 77.7378 66.6179 74.721 68.4236 72.3425C65.7893 72.3425 63.3451 71.4699 61.3301 69.9876C59.3152 71.4706 56.871 72.3425 54.2361 72.3425C53.5175 72.3425 52.9343 71.7252 52.9343 70.964C52.9343 70.2028 53.5175 69.586 54.2361 69.586C56.0815 69.586 57.8084 69.045 59.2869 68.1082C57.5035 66.0709 56.3178 63.4404 56.0309 60.5293H54.2367C53.5175 60.5293 52.9343 59.9125 52.9343 59.1513C52.9343 58.3901 53.5175 57.7728 54.2367 57.7728H60.0289V54.4263C60.0289 53.6645 60.6116 53.0477 61.3307 53.0477C62.0499 53.0477 62.6325 53.6645 62.6325 54.4263V57.7728H68.4248C69.1439 57.7728 69.7272 58.3901 69.7272 59.1513C69.7272 59.9125 69.1439 60.5293 68.4248 60.5293H66.6305C66.3437 63.4404 65.158 66.0709 63.3745 68.1082C64.8525 69.0463 66.58 69.586 68.4248 69.586C69.1121 69.586 69.6737 70.1499 69.7224 70.8647C72.0644 68.5582 75.2001 67.1433 78.6437 67.1433H84.6615V61.335L92.3508 55.5216C92.9569 55.0634 93.3171 54.3225 93.3171 53.5333C93.3171 52.7435 92.9569 52.0027 92.3508 51.5444L84.5689 45.661C83.9604 41.3318 80.4254 38 76.1694 38H46.492C41.8092 38 38 42.0319 38 46.988V78.4022C38 83.3583 41.8092 87.3902 46.492 87.3902H65.5338V81.0193Z"
            fill={secondaryColor}
          />
          <path
            id="Path_3"
            d="M61.7071 65.6586C62.7594 64.6026 63.4738 63.2314 63.6829 61.7073H59.7317C59.9408 63.2314 60.6557 64.6026 61.7071 65.6586Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

LanguagesIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
LanguagesIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(LanguagesIcon);
memoized.displayName = 'LanguagesIcon';
export default memoized;
